import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '@services/messagingService';

import { EcommerceSectionNamespace } from '../../../model';

export const trackFreeDeliveryStatus = () => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.STATUS_SET,
      status: {
        type: EcommerceSectionNamespace.EEcommerceType.CHECKOUT,
        name: EcommerceSectionNamespace.EEcommerceName.FREE_DELIVERY,
      },
      _clear: true,
    }),
  );
};
